import { baseUrl } from '@/settings'
import { get } from '../rest'

const privilegeApi = {
    session: () => get(`${baseUrl}/config/roleaccess/session`)
}
export default privilegeApi
